<template>
  <Modal :show-modal="showAreaOfWorkModal" class="areaOfWorkModal">
    <template #header>
      <TitleSmall :title="$t('customer.area_of_work.modal.title')" />
      <TextSmall>
        {{ $t('customer.area_of_work.modal.description') }}
      </TextSmall>
    </template>
    <template #body>
      <div class="areaOfWorkModal__cards">
        <div
          v-for="area in areas"
          :key="area.title"
          class="areaOfWorkModal__cards__card"
          :class="{ active: selectedItem === area.identifier }"
          @click="selectedItem = area.identifier"
        >
          <img
            class="areaOfWorkModal__cards__card--img"
            :src="require(`@/assets/illustrations/${area.img}.png`)"
          />
          <TextSmall class="areaOfWorkModal__cards__card--title" bold>{{
            area.title
          }}</TextSmall>
        </div>
      </div>
    </template>
    <template #footer>
      <BtnPrimary
        :title="$t('shared.button.next')"
        class="areaOfWorkModal__btn"
        :disabled="!selectedItem"
        @click="handleNext"
      />
    </template>
  </Modal>
</template>
<script setup>
import BtnPrimary from '@/components/shared/btn/BtnPrimary'
import TextSmall from '@/components/shared/font/text/TextSmall'
import TitleSmall from '@/components/shared/font/title/TitleSmall'
import Modal from '@/components/shared/Modal'
import i18n from '@/i18n'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const route = useRoute()
const router = useRouter()
const $t = i18n.t

const selectedItem = ref('')
const areas = ref([
  {
    title: $t('customer.area_of_work.modal.marketing'),
    img: 'marketing',
    identifier: 'Marketing'
  },
  {
    title: $t('customer.area_of_work.modal.operations'),
    img: 'operations',
    identifier: 'Operations team'
  },
  {
    title: $t('customer.area_of_work.modal.product'),
    img: 'product',
    identifier: 'Product'
  },
  {
    title: $t('customer.area_of_work.modal.localisation'),
    img: 'localisation',
    identifier: 'Localisation team'
  },
  {
    title: $t('customer.area_of_work.modal.tech'),
    img: 'tech',
    identifier: 'Data/digitization'
  },
  {
    title: $t('customer.area_of_work.modal.other'),
    img: 'other',
    identifier: 'Other'
  }
])

const isAdmin = computed(() => store.getters['workspace/isAdmin'])
const showAreaOfWorkModal = computed(
  () => store.state.modals.showAreaOfWorkModal
)

const sendPlgGoalForm = (payload) =>
  store.dispatch('teams/sendPlgGoalForm', payload)
const toggleAreaOfWorkModal = () => store.commit('modals/toggleAreaOfWorkModal')
const toggleCaasAnimationModal = () =>
  store.commit('modals/toggleCaasAnimationModal')

function handleNext() {
  sendPlgGoalForm({ area_of_work: selectedItem.value })
  if (route.name === 'contentGenerationV2') {
    toggleCaasAnimationModal()
  }
  toggleAreaOfWorkModal()
}

onMounted(() => {
  selectedItem.value = ''
})

watch(
  () => showAreaOfWorkModal.value,
  (show) => {
    if (show && isAdmin.value) toggleAreaOfWorkModal()
  }
)
</script>

<style scoped lang="scss">
.areaOfWorkModal {
  :deep(.modal-wrapper) {
    max-width: 800px;
    @include desktop() {
      width: 1250px;
    }
    .modal-container {
      text-align: center;
      &::-webkit-scrollbar {
        display: none !important; /* Chrome Safari */
      }
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      .modal-header {
        .textSmall {
          margin: 0.5rem 0 2rem 0;
        }
      }
    }
  }
  &__cards {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-auto-rows: max-content;
    grid-auto-flow: row dense;
    grid-column-gap: 1.25rem;
    grid-row-gap: 1.25rem;
    &__card {
      width: 100%;
      padding: 1.3rem;
      text-align: center;
      border-radius: 10px;
      border: 1px solid #cfd3dc;
      background-color: #ffffff;
      cursor: pointer;
      box-shadow: 2px 2px 4px 0px #0b153a1a;
      &:hover,
      &.active {
        background-color: #f3f6fa;
        border: 1px solid #2c3fd5;
      }
      &--img {
        height: 80px;
        width: 80px;
        margin: auto;
      }
    }
  }
  &__btn {
    padding: 10px 60px;
    margin-top: 1rem;
  }
}
</style>
